import React from 'react';
import {
  PORTFOLIO_ABOUT,
  PORTFOLIO_CONTACT,
  portfolioProjects,
} from '../data/portfolioPdf';
import './PortfolioPdf.css';

const totalPages = 1 + portfolioProjects.length;

const PageFooter = ({ page }) => (
  <footer className="ppdf__footer">
    <span>{PORTFOLIO_CONTACT.name}</span>
    <span>
      {page} / {totalPages}
    </span>
  </footer>
);

const CoverPage = () => (
  <section className="ppdf-page ppdf-page--cover" aria-label="Cover">
    <div className="ppdf-cover">
      <div className="ppdf-cover__main">
        <header className="ppdf-cover__header">
          <h1 className="ppdf-cover__name">{PORTFOLIO_CONTACT.name}</h1>
          <p className="ppdf-cover__meta">
            {PORTFOLIO_CONTACT.role}
            <span className="ppdf-cover__dot" aria-hidden="true">
              ·
            </span>
            {PORTFOLIO_CONTACT.location}
          </p>
        </header>

        <div className="ppdf-cover__block">
          <span className="ppdf-pill ppdf-pill--label">About</span>
          <p className="ppdf-cover__about">{PORTFOLIO_ABOUT}</p>
        </div>

        <div className="ppdf-cover__block">
          <span className="ppdf-cover__label">Selected Work</span>
          <div className="ppdf-cover__tags">
            {portfolioProjects.map((project) => (
              <span key={project.id} className="ppdf-pill">
                {project.title}
              </span>
            ))}
          </div>
        </div>
      </div>

      <aside className="ppdf-cover__aside">
        <div className="ppdf-cover__block">
          <span className="ppdf-cover__label">Contact</span>
          <div className="ppdf-cover__contact">
            <a href={`mailto:${PORTFOLIO_CONTACT.email}`}>
              {PORTFOLIO_CONTACT.email}
            </a>
            <a
              href={`https://${PORTFOLIO_CONTACT.site}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {PORTFOLIO_CONTACT.site}
            </a>
            <a
              href={PORTFOLIO_CONTACT.linkedin}
              target="_blank"
              rel="noopener noreferrer"
            >
              {PORTFOLIO_CONTACT.linkedinLabel}
            </a>
          </div>
        </div>
        <p className="ppdf-cover__doc-label">Portfolio</p>
      </aside>
    </div>
    <PageFooter page={1} />
  </section>
);

const ProjectPage = ({ project, page }) => (
  <section
    className="ppdf-page ppdf-page--project"
    aria-label={project.title}
  >
    <div className="ppdf-project">
      <aside className="ppdf-project__sidebar">
        <h2 className="ppdf-project__title">{project.title}</h2>
        <div className="ppdf-project__description">
          {project.description.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
          {project.href ? (
            <p>
              Live at{' '}
              <a
                href={project.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {project.hrefLabel || project.href}
              </a>
            </p>
          ) : null}
        </div>
        {project.credits?.length ? (
          <div className="ppdf-project__credits">
            <div className="ppdf-project__credits-head">Credits</div>
            <div className="ppdf-project__credits-body">
              {project.credits.map((credit) => (
                <span key={credit}>{credit}</span>
              ))}
            </div>
          </div>
        ) : null}
      </aside>

      <div
        className={`ppdf-project__media${
          project.tallHero ? ' ppdf-project__media--tall-hero' : ''
        }`}
      >
        <div className="ppdf-project__hero">
          <img
            src={project.images.large.src}
            alt={project.images.large.alt}
            style={
              project.images.large.objectPosition
                ? { objectPosition: project.images.large.objectPosition }
                : undefined
            }
          />
        </div>
        <div className="ppdf-project__row">
          {project.images.small.map((image) => (
            <div
              key={image.alt}
              className={`ppdf-project__thumb${
                image.letterboxWhite ? ' ppdf-project__thumb--letterbox-white' : ''
              }`}
              style={
                image.letterboxScale
                  ? { '--letterbox-scale': image.letterboxScale }
                  : undefined
              }
            >
              <img
                src={image.src}
                alt={image.alt}
                style={
                  image.objectPosition
                    ? { objectPosition: image.objectPosition }
                    : undefined
                }
                className={
                  image.letterboxWhite ? 'ppdf-project__thumb-img--letterbox' : undefined
                }
              />
            </div>
          ))}
        </div>
      </div>
    </div>
    <PageFooter page={page} />
  </section>
);

const PortfolioPdf = () => {
  return (
    <div className="ppdf">
      <div className="ppdf__screen-bar no-print">
        <span>A4 landscape portfolio preview</span>
        <button type="button" onClick={() => window.print()}>
          Print / Save as PDF
        </button>
      </div>

      <CoverPage />
      {portfolioProjects.map((project, index) => (
        <ProjectPage
          key={project.id}
          project={project}
          page={index + 2}
        />
      ))}
    </div>
  );
};

export default PortfolioPdf;
